<ng-container *ngIf="medias && medias.length > 0; else noMediaBlock">
  <app-print [media]="media" *ngFor="let media of medias"></app-print>
</ng-container>

<ng-template #noMediaBlock>
  <app-print [media]="null"></app-print>
</ng-template>
